import React from 'react';
import { Pie } from '@ant-design/plots';

const PieChart: React.FC<{
  configChart?: any;
}> = ({ configChart }) => <Pie {...configChart} />;

export default PieChart;
